import { render } from "./IgnoredEntityModal.vue?vue&type=template&id=5b4d99e1&scoped=true"
import script from "./IgnoredEntityModal.vue?vue&type=script&lang=js"
export * from "./IgnoredEntityModal.vue?vue&type=script&lang=js"

import "./IgnoredEntityModal.vue?vue&type=style&index=0&id=5b4d99e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4d99e1"]])

export default __exports__